<template>
  <!-- The progress bar the mobile apps show across their signup steps
       (iOS OnBoardingCurrentStepViewController, Android's tab1…tab6 row):
       completed and current segments in brand yellow, the rest muted. -->
  <div class="step-indicator" role="group" :aria-label="stepLabel">
    <span
      v-for="step in total"
      :key="step"
      class="step-indicator__segment"
      :class="{ 'step-indicator__segment--done': step <= current }"
    ></span>
    <span class="visually-hidden">{{ stepLabel }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'OnBoardingStepIndicator',
  props: {
    current: { type: Number, required: true },
    total: { type: Number, default: 8 },
  },
  computed: {
    // Screen readers get the position as words; the segments themselves are
    // decorative, so they carry no individual labels.
    stepLabel(): string {
      return this.$t('on_boarding.profile_steps.step_of', { current: this.current, total: this.total });
    },
  },
});
</script>

<style scoped>
/* Sits in the dialog's top row, between Back and Close (OnBoardingFrame). */
.step-indicator {
  display: flex;
  flex: 1;
  min-width: 0;
  gap: 6px;
}
.step-indicator__segment {
  flex: 1;
  height: 4px;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.14);
  transition: background-color 0.2s ease;
}
.step-indicator__segment--done {
  background: linear-gradient(180deg, #ffe93d 0%, var(--yellow, #fddf00) 100%);
}

/* Bootstrap ships .visually-hidden, but the modal/standalone pages don't both
   guarantee it, so keep a local copy. */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
